import {v4 as uuidv4} from "uuid";
import firestore      from "@/firebase/async-firestore";
import firebase       from "firebase";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
import {isNil}        from "lodash";
import store          from "@/store";
import GenericDB      from "./generic-db";

export default class ChatsDb extends GenericDB {
    constructor(demandId) {
        super(`demands/${demandId}/chats`);
        this.collectionPath = `demands/${demandId}/chats`;
    }

    async readAllOnChange() {
        return (await firestore())
            .collection(this.collectionPath)
            .orderBy("createTimestamp", "asc")
            .onSnapshot(
                querySnapshot => {
                    // Empty Chat to accept new messages
                    store.commit("chats/emptyMessages");

                    const messages = [];

                    // Iterate messages
                    querySnapshot.forEach(
                        doc => {
                            messages.push(
                                {
                                    id: doc.ref.id,
                                    ...doc.data()
                                }
                            );
                        }
                    );

                    store.commit(
                        "chats/appendMessages",
                        messages
                    );
                }
            );
    }

    /**
     * Create a document in the collection
     * @param data
     * @param id
     */
    async create(data, id = null) {
        const collectionRef   = (await firestore()).collection(this.collectionPath);
        const serverTimestamp = firebase.firestore.FieldValue.serverTimestamp();

        const dataToCreate = {
            ...data,
            createTimestamp: serverTimestamp,
            updateTimestamp: serverTimestamp
        };

        if (isNil(id)) {
            id = uuidv4();
        }

        const docId = await collectionRef
            .doc(id)
            .set(dataToCreate)
            .then(() => id)
            .catch(() => {
            });

        return {
            id: docId,
            ...data,
            createTimestamp: new Date(),
            updateTimestamp: new Date()
        };
    }

    /**
     * Delete a document in the collection
     * @param id
     */
    async delete(id) {
        return (await firestore())
            .collection(this.collectionPath)
            .doc(id);
    }
}
